'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'eSignature Free SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Use eSignatures for Free',
            subtitle: 'Send your first eSignature for free',
            buttonText: 'Create a Free Account'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Can I use HelloSign eSignatures for free?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can begin signing documents for free by signing up for a HelloSign account. Our starter plan gives you three free eSignature requests per month and access to our user-friendly signer experience. You can upgrade to any pro plan or above for unlimited signatures.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What happens if I need more than three signature requests?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Your first three signature requests are free. With an upgraded plan, you can send unlimited signature requests and enjoy HelloSign templates to format your frequently used documents. ',
                _react2['default'].createElement(
                    'a',
                    { target: '_blank', rel: 'noopener noreferrer',
                        href: 'https://app.hellosign.com/info/pricing' },
                    'Learn more about our plans here.'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How can I use free eSignatures to sign documents online?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'It\u2019s simple to start signing for free! Once you\u2019ve activated a HelloSign account, you can begin your first signature request. Start by uploading the document you\u2019d like to have signed and format it with a signature field. Format other fields like name of signer and custom signature request message, then send your doc.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You\u2019ll receive automatic email reminders to update you on the progress of the document.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can see what a signature request looks like from the signer\u2019s perspective ',
                _react2['default'].createElement(
                    'a',
                    { target: '_blank', rel: 'noopener noreferrer', href: 'https://faq.hellosign.com/hc/en-us/articles/210929317-What-does-a-signature-request-look-like-from-the-signer-s-perspective-New-' },
                    'here'
                ),
                '.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How else can I use HelloSign?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'While we\u2019re the fastest and easiest way to get documents signed online, we\u2019re also proud to offer a bunch of handy tools to our users. These include:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Document templates.'
                    ),
                    ' Templates save you the trouble of re-formatting your frequently used documents over and over. Simply upload a document, format with the appropriate fields, then save as a template you can use again and again.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Integrations.'
                    ),
                    ' HelloSign also makes it easy to sign paper in your existing apps. This means you can sign documents in apps like ',
                    _react2['default'].createElement(
                        'a',
                        { target: '_blank', rel: 'noopener noreferrer',
                            href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/' },
                        'Evernote'
                    ),
                    ',',
                    _react2['default'].createElement(
                        'a',
                        { href: 'http://blog.hellosign.com/dropbox/',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Dropbox'
                    ),
                    ', Google (including ',
                    _react2['default'].createElement(
                        'a',
                        {
                            href: 'https://www.hellosign.com/gmail',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Gmail'
                    ),
                    ', ',
                    _react2['default'].createElement(
                        'a',
                        {
                            href: 'https://www.hellosign.com/googledrive',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'Google Drive'
                    ),
                    ', and ',
                    _react2['default'].createElement(
                        'a',
                        {
                            href: 'https://www.hellosign.com/google-docs-add-on',
                            target: '_blan' },
                        'Google Docs'
                    ),
                    ').'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    _react2['default'].createElement(
                        'strong',
                        null,
                        'Mobile Signing.'
                    ),
                    ' Our signer experience was created with multiple devices in mind. That means it\u2019s easy to sign contracts or paperwork on the go from your desktop, tablet, or mobile device.'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How is HelloSign different from other free eSignature apps?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'The thing that sets HelloSign apart from the rest is our straightforward and friendly signer experience. We are and have always been focused on giving our users the best signing experience possible. That means providing an easy-to-navigate and intuitive signer page that guides users smoothly through the signing flow.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'For you as a signer, that means a more pleasant signing experience and an overall better user experience. To read more about our signer page updates, ',
                _react2['default'].createElement(
                    'a',
                    { href: 'http://blog.hellosign.com/new-signer-experience/',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'visit here'
                ),
                '.'
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'Start signing! You can sign up for a free account to test out any of our plans. If you want to connect with a HelloSign specialist to learn more about our business and team plans, schedule a demo.',
            signupButtonText: 'CREATE A FREE HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/e-signature-free.jsx
 ** module id = 1208
 ** module chunks = 0
 **/